export default __webpack_public_path__ + "c7ca291a65cb03a8219b1fe97ac6b7a3.png";